import { useState, useEffect, useCallback, useRef } from "react";

const usePlaybackTime = (player: any) => {
  const [seconds, setSeconds] = useState(0);

  const updatePlayerTime = useCallback(async () => {
    const currentSecond = Math.floor(player.currentTime);
    if (currentSecond !== seconds) {
      setSeconds(currentSecond);
    }
  }, [player, seconds]);

  useEffect(() => {
    if (!player) return;
    player.addEventListener("timeupdate", updatePlayerTime);
    return () => player.removeEventListener("timeupdate", updatePlayerTime);
  }, [player, updatePlayerTime]);

  return seconds;
};

export default usePlaybackTime;
